$(document).ready(function () {
    const updateMainSlider = (index) => {
        const $mainSlider = $("#MainContent .main-slider");
        const $slides = $("#MainContent .main-slide");
        const slidesCount = $slides.length;
        if (!slidesCount) return;

        index = parseInt(index, 10) || 0;
        if (index < 0) index = 0;
        if (index >= slidesCount) index = slidesCount - 1;

        const offset = -index * 100;
        $mainSlider.css("transform", `translateX(${offset}%)`);

        // data-index lives on .main-slide (not the img)
        $slides.removeClass("active");
        $slides.find("img").removeClass("active");

        const $activeSlide = $slides.filter('[data-index="' + index + '"]').addClass("active");
        $activeSlide.find("img").addClass("active");

        $("#MainContent .short-image img, #MainContent .thumb")
            .removeClass("active")
            .filter('[data-index="' + index + '"]')
            .addClass("active");

        const $prev = $("#MainContent .slider-arrow.prev, #MainContent .slider-btn.prev-btn");
        const $next = $("#MainContent .slider-arrow.next, #MainContent .slider-btn.next-btn");
        if (index === 0) $prev.addClass("disabled"); else $prev.removeClass("disabled");
        if (index >= slidesCount - 1) $next.addClass("disabled"); else $next.removeClass("disabled");
    };

    let pdpGalleryHandlersBound = false;

    const initializeSlider = () => {
        const $slides = $("#MainContent .main-slide");
        if (!$slides.length) return;

        let activeIndex = 0;
        let startX = 0;

        const $withActive = $slides.filter(".active").first();
        if ($withActive.length) {
            activeIndex = parseInt($withActive.attr("data-index"), 10) || 0;
        } else {
            const $activeImg = $slides.find("img.active").first();
            if ($activeImg.length) {
                activeIndex = parseInt($activeImg.closest(".main-slide").attr("data-index"), 10) || 0;
            }
        }

        if (!pdpGalleryHandlersBound) {
            pdpGalleryHandlersBound = true;

            $("#MainContent").on("click", ".thumb", function () {
                activeIndex = parseInt($(this).attr("data-index"), 10) || 0;
                $("#MainContent .thumb").removeClass("active");
                $(this).addClass("active");
                updateMainSlider(activeIndex);
            });

            $("#MainContent").on("touchstart", ".main-slider", function (e) {
                startX = e.originalEvent.touches[0].clientX;
            });

            $("#MainContent").on("touchend", ".main-slider", function (e) {
                const endX = e.originalEvent.changedTouches[0].clientX;
                const deltaX = endX - startX;
                const maxIndex = $("#MainContent .main-slide").length - 1;

                if (deltaX > 50 && activeIndex > 0) {
                    activeIndex--;
                } else if (deltaX < -50 && activeIndex < maxIndex) {
                    activeIndex++;
                }

                updateMainSlider(activeIndex);
            });

            $("#MainContent").on("click", ".slider-btn.prev-btn", function () {
                if (activeIndex > 0) {
                    activeIndex--;
                    updateMainSlider(activeIndex);
                }
            });

            $("#MainContent").on("click", ".slider-btn.next-btn", function () {
                if (activeIndex < $("#MainContent .main-slide").length - 1) {
                    activeIndex++;
                    updateMainSlider(activeIndex);
                }
            });
        }

        updateMainSlider(activeIndex);
    };

    initializeSlider();

    $(document).ajaxComplete(function () {
        initializeSlider();
    });
});


$(document).ready(function () {
    const DESKTOP_MIN = 990;
    const ZOOM = 2.5;
    const GLASS_W = 420;
    const GLASS_H = 420;

    function isDesktopMagnify() {
        return window.innerWidth >= DESKTOP_MIN;
    }

    function getGlass() {
        let glass = document.getElementById("magnifyGlass");
        if (!glass) {
            glass = document.createElement("div");
            glass.id = "magnifyGlass";
            glass.className = "magnifyGlass";
            glass.setAttribute("aria-hidden", "true");
            document.body.appendChild(glass);
        } else if (glass.parentElement !== document.body) {
            // Reparent out of clipped gallery containers
            document.body.appendChild(glass);
        }
        return $(glass);
    }

    function getSlideImage($slide) {
        if (!$slide || !$slide.length) return $();
        return $slide.find("img.mainImage, img.product-image, img").first();
    }

    function hideMagnifyGlass() {
        const glass = document.getElementById("magnifyGlass");
        if (!glass) return;
        glass.classList.remove("is-visible");
        glass.style.setProperty("visibility", "hidden", "important");
        glass.style.setProperty("opacity", "0", "important");
        glass.style.setProperty("background-image", "none", "important");
    }

    function updateMagnifyGlass($img, e) {
        if (!isDesktopMagnify() || !$img.length) {
            hideMagnifyGlass();
            return;
        }

        const imgEl = $img[0];
        const rect = imgEl.getBoundingClientRect();
        const imgW = rect.width;
        const imgH = rect.height;

        if (!imgW || !imgH) {
            hideMagnifyGlass();
            return;
        }

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        if (x < 0 || y < 0 || x > imgW || y > imgH) {
            hideMagnifyGlass();
            return;
        }

        const src =
            $img.attr("data-zoom-src") ||
            $img.attr("data-src") ||
            $img.attr("src");

        if (!src) {
            hideMagnifyGlass();
            return;
        }

        const $glass = getGlass();
        const glass = $glass[0];

        // Prefer right of image; flip left if not enough room
        let left = rect.right + 16;
        let top = rect.top;

        if (left + GLASS_W > window.innerWidth - 12) {
            left = rect.left - GLASS_W - 16;
        }
        if (left < 12) left = 12;

        if (top + GLASS_H > window.innerHeight - 12) {
            top = window.innerHeight - GLASS_H - 12;
        }
        if (top < 12) top = 12;

        const bgX = -(x * ZOOM - GLASS_W / 2);
        const bgY = -(y * ZOOM - GLASS_H / 2);
        const safeUrl = src.replace(/\\/g, "\\\\").replace(/"/g, '\\"');

        // Must use setProperty(..., 'important') to beat base.css locks
        glass.classList.add("is-visible");
        glass.style.setProperty("display", "block", "important");
        glass.style.setProperty("visibility", "visible", "important");
        glass.style.setProperty("opacity", "1", "important");
        glass.style.setProperty("position", "fixed", "important");
        glass.style.setProperty("left", left + "px", "important");
        glass.style.setProperty("top", top + "px", "important");
        glass.style.setProperty("right", "auto", "important");
        glass.style.setProperty("width", GLASS_W + "px", "important");
        glass.style.setProperty("height", GLASS_H + "px", "important");
        glass.style.setProperty("z-index", "99999", "important");
        glass.style.setProperty("pointer-events", "none", "important");
        glass.style.setProperty("background-color", "#fff", "important");
        glass.style.setProperty("background-image", 'url("' + safeUrl + '")', "important");
        glass.style.setProperty("background-repeat", "no-repeat", "important");
        glass.style.setProperty(
            "background-size",
            imgW * ZOOM + "px " + imgH * ZOOM + "px",
            "important"
        );
        glass.style.setProperty(
            "background-position",
            bgX + "px " + bgY + "px",
            "important"
        );
        glass.style.setProperty("border-radius", "10px", "important");
        glass.style.setProperty("border", "2px solid #d9d9d9", "important");
        glass.style.setProperty(
            "box-shadow",
            "0 8px 28px rgba(0,0,0,0.18)",
            "important"
        );
    }

    // Hover the product image (desktop)
    $("#MainContent").on(
        "mousemove",
        ".main-slide.product-image-container, .main-slide",
        function (e) {
            if (!isDesktopMagnify()) return;

            const $slide = $(this);
            if ($slide.find("video, .product-video").length && !$slide.find("img").length) {
                hideMagnifyGlass();
                return;
            }

            updateMagnifyGlass(getSlideImage($slide), e);
        }
    );

    // Hide when leaving the image area (ignore leave into magnify — pointer-events none)
    $("#MainContent").on("mouseleave", ".image-slider, .main-slide", function (e) {
        const related = e.relatedTarget;
        if (related && related.closest && related.closest("#magnifyGlass")) return;
        // Still inside another main-slide / image-slider?
        if (related && $(related).closest(".image-slider, .main-slide").length) return;
        hideMagnifyGlass();
    });

    $(window).on("scroll resize", hideMagnifyGlass);

    $("#MainContent").on("click", ".mainImage", function () {
        $("#MainContent .lightbox-modal").show();
        $("#MainContent #lightbox-image").attr("src", $(this).attr("src"));
    });

    $("#MainContent").on("click", ".lightbox-close", function () {
        $("#MainContent .lightbox-modal").hide();
    });

    $("#MainContent").on("click", "#lightbox-image", function () {
        $(this).toggleClass("zoom-in");
    });
});
